import { defineStore } from 'pinia';
import { SnackbarOptions } from '~~/data/interfaces/stores/SnackbarOptions';
import { SnackbarState } from '~~/data/interfaces/stores/SnackbarState';

export const useSnackbar = defineStore('snackbar', {
    state: (): SnackbarState => ({
        title: null,
        message: null,
        persistent: null,
        duration: null,
        active: false,
    }),

    actions: {
        setSnackbar(options: SnackbarOptions) {
            this.title = options.title || '';
            this.message = options.message || '';
            this.persistent = options.persistent || false;
            this.duration = options.duration || (options.persistent ? null : 9500);
            this.active = true;

            if (!this.persistent && this.duration) {
                setTimeout(() => {
                    this.closeSnackbar();
                }, this.duration);
            }
        },

        closeSnackbar() {
            this.title = null;
            this.message = null;
            this.persistent = null;
            this.duration = null;
            this.active = false;
        },
    },
});
